import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    attendees: [],
    totalCount: 0,
    loading: false,
    error: null
};
const familyFestAttendeesSlice = createSlice({
    name: 'familyFestAttendees',
    initialState,
    reducers: {
        fetchAttendeesStart(state) {
            state.loading = true;
            state.error = null;
        },
        fetchAttendeesSuccess(state, action) {
            state.attendees = action.payload.items;
            state.totalCount = action.payload.totalCount;
            state.loading = false;
            state.error = null;
        },
        fetchAttendeesFailure(state, action) {
            state.loading = false;
            state.error = action.payload;
        }
    }
});
export const { fetchAttendeesStart, fetchAttendeesSuccess, fetchAttendeesFailure } = familyFestAttendeesSlice.actions;
export default familyFestAttendeesSlice.reducer;
